import { render } from "./ProductList.vue?vue&type=template&id=69284b7b&scoped=true&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import "./ProductList.vue?vue&type=style&index=0&id=69284b7b&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69284b7b"]])

export default __exports__